"use client";

import cnBind from "classnames/bind";
import { useTranslation } from "react-i18next";

import styles from "./PaymentAcquiring.module.scss";

const cx = cnBind.bind(styles);

type ProviderAsset = {
    id: string;
    src?: string;
    pad: "icon" | "wide";
    mark?: boolean;
};

const PROVIDER_ASSETS: ProviderAsset[] = [
    { id: "bepaid", src: "/images/acquiring/bepaid.png", pad: "icon" },
    { id: "alfa", src: "/images/acquiring/alfa-bank.png", pad: "wide" },
    { id: "erip", src: "/images/acquiring/erip.jpg", pad: "wide" },
    { id: "belkart", src: "/images/acquiring/belkart.png", pad: "icon" },
    { id: "installment", src: "/images/acquiring/installment.svg", pad: "wide" },
    { id: "other", pad: "wide", mark: true },
];

/** Compact proof: Tezam integrates any acquiring — BePaid, Alfa, ERIP, custom. */
export const PaymentAcquiring = () => {
    const { t } = useTranslation("common");
    const providers = t("home.payment.providers", { returnObjects: true }) as {
        id: string;
        name: string;
        note: string;
        mark?: string;
    }[];
    const byId = new Map((Array.isArray(providers) ? providers : []).map((p) => [p.id, p]));

    return (
        <section className={cx("section")} aria-labelledby="payment-acquiring-title">
            <div className={cx("wrapper", "container")}>
                <div className={cx("head")}>
                    <span className={cx("eyebrow")}>{t("home.payment.eyebrow")}</span>
                    <h2 id="payment-acquiring-title">{t("home.payment.title")}</h2>
                    <p className={cx("seoOnly")}>{t("home.payment.seo")}</p>
                </div>

                <ul className={cx("providers")}>
                    {PROVIDER_ASSETS.map((item) => {
                        const copy = byId.get(item.id);
                        const name = copy?.name ?? item.id;
                        return (
                            <li key={item.id} className={cx("provider")}>
                                <div className={cx("logoWrap", item.pad)}>
                                    {item.src ? (
                                        <img
                                            src={item.src}
                                            alt={name}
                                            className={cx("logo")}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    ) : (
                                        <span className={cx("mark")}>{copy?.mark ?? "YOURS"}</span>
                                    )}
                                </div>
                                <strong>{name}</strong>
                                <span>{copy?.note}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
};
